import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";
import { v_LocationDetailBus } from "./v_LocationDetailBus";
import { InvoiceCheckListNoteBus } from "./InvoiceCheckListNoteBus";

export class v_InvoiceCheckListNoteBus extends BaseBus
{
    constructor(busObj: v_InvoiceCheckListNoteBus = null) {
        super(busObj);
        this.insertDt = DateFunctions.getDate(this.insertDt);
        this.updatedt = DateFunctions.getDate(this.updatedt);
    }
    CID(): any {
        return this.invoiceCheckListNotesId;
    }
    setParentId(id: any) {
        this.customerId = id;
    }
    setId(id: any) {
        this.invoiceCheckListNotesId = id;
    }
    setFromBusobj(data: InvoiceCheckListNoteBus) {
        this.initialize(data);
        this.invoiceCheckListNotes = data.invoiceCheckListNotes1;
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: v_LocationDetailBus = null) {
        this.invoiceCheckListNotesPersonId = personId;
        this.visibleToCustomer = false;
        this.highlight = false;
        this.techNote = false;
        this.isWarning = false;
    }
    setCommon(userId: any, date: Date, companyId: any = null, personId: any = null) {
        if (!DateFunctions.isValidDate(this.insertDt)) {
            this.insertDt = date;
            this.insertUserId = userId;
        }
        this.updatedt = date;
        this.updateUserId = userId;
        if (!CommonFunctions.hasGuidValue(this.invoiceCheckListNotesPersonId)) {
            this.invoiceCheckListNotesPersonId = personId;
        }
    }
  invoiceCheckListNotesId: any;
  invoiceCheckListNotes: string;
  visibleToCustomer: boolean;
  personName: string;
  highlight: boolean;
  isWarning: boolean;
  techNote: boolean;
  updateUserId: any;
  updatedt: Date;
  insertUserId: any;
  insertDt: Date;
  customerId: any;
  invoiceCheckListNotesPersonId: any;
  hideLogBook: any;
  //assignedPersonId: any;
}
